// Webpack 5 dropped automatic Node global polyfills. Several bundled libs
// (readable-stream, util, form-data, etc.) reference Buffer and process as
// globals at module-load time. Provide them on window here so they're available
// before any other imports run.
import { Buffer as BufferPolyfill } from 'buffer'
import processPolyfill from 'process/browser'
;(globalThis as typeof globalThis & { Buffer: typeof BufferPolyfill }).Buffer = BufferPolyfill
;(globalThis as typeof globalThis & { process: typeof processPolyfill }).process = processPolyfill
